import { object } from '@iwentsourcing/core/typing/object.js';
import { string } from '@iwentsourcing/core/typing/string.js';

export const AuthDeviceCodeRequest = object('AuthDeviceCodeRequest', {
  tenant: string(),
  realm: string(),
  provider: string(),
});
